import { createReduxActionCreator } from '../types';
import { ClientDevicePushNotificationsResponse, ClientDeviceState } from './clientDeviceTypes';

export const CLIENT_DEVICE_ACTION_PREFIX = 'client-device-redux/';

export const getRegisterClientDeviceActions = createReduxActionCreator<ClientDeviceState>(`${CLIENT_DEVICE_ACTION_PREFIX}register-client-device`);
export const getClientDeviceDeleteActions = createReduxActionCreator<undefined>(`${CLIENT_DEVICE_ACTION_PREFIX}client-device-delete`);
export const getPushNotificationsActions = createReduxActionCreator<ClientDevicePushNotificationsResponse>(`${CLIENT_DEVICE_ACTION_PREFIX}get-push-notifications`);
